import {TypeCoord} from './TypeCoord';
import {TypePers} from './TypePers';
import {TypeAdresse} from './TypeAdresse';
export class Envoi {

	public coord: TypeCoord;

	public personnePhysique: TypePers;

	public conditionsRemise: string;

	public personneMorale: string;

	public adr: TypeAdresse;

	constructor() { 
		 		this.coord = new TypeCoord();
		this.personnePhysique = new TypePers();
		this.conditionsRemise = '';
		this.personneMorale = '';
		this.adr = new TypeAdresse();
 
	}
}
